import { render, staticRenderFns } from "./FormAddContact.vue?vue&type=template&id=4ffc15da&"
import script from "./FormAddContact.vue?vue&type=script&lang=js&"
export * from "./FormAddContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports